import React, { FC, memo, useEffect } from 'react';
import { Navigate, Outlet, useNavigate, useParams } from 'react-router';
import { LANDING_HOSTNAME } from '../config';
import Button from '../components/ui/Button';
import classNames from 'classnames';
import IconSvg from '../components/ui/IconSvg';
import useLastCallback from '../hooks/useLastCallback';
import { ensureProtocol } from '../util/ensureProtocol';
import { useTranslation } from 'react-i18next';
import { ERoutes } from '../types';
import { ApiUpdateAuthorizationStateType } from '../api/types';
import { withGlobal } from '../global';

type StateProps = {
  authState?: ApiUpdateAuthorizationStateType;
};

const AuthLayout: FC<StateProps> = ({ authState }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { tab } = useParams();
  const showBack =
    tab && [ERoutes.createAccount, ERoutes.blocked].includes(tab as ERoutes);

  const openSupport = useLastCallback(() => {
    window.open(
      ensureProtocol(`${LANDING_HOSTNAME}/support`),
      '_blank',
      'noopener'
    );
  });

  const handleBack = useLastCallback(() => {
    switch (tab) {
      case ERoutes.createAccount:
        navigate(`${ERoutes.auth}/${ERoutes.signUp}`);
        break;

      default:
        navigate(-1);
    }
  });

  useEffect(() => {
    if (authState === 'authorizationStateWhatUserBlocked') {
      navigate(`${ERoutes.auth}/${ERoutes.blocked}`, {
        state: { fromSignin: true },
      });
    } else if (authState === 'authorizationStateWaitRegistration') {
      navigate(`${ERoutes.auth}/${ERoutes.signUp}`);
    }
  }, [authState]);

  if (authState === 'authorizationStateReady')
    return <Navigate to='/' replace />;

  return (
    <div className='Auth custom-scroll'>
      <header className='AuthHeader'>
        <Button
          className={classNames({ hidden: !showBack })}
          round
          size='smaller'
          color='translucent'
          onClick={handleBack}
        >
          <i className='icon-svg color-text'>
            <IconSvg name='arrow-left' />
          </i>
        </Button>

        {/* <SelectLanguage /> */}
        <div className='right-header'>
          <Button
            round
            size='smaller'
            color='translucent'
            onClick={openSupport}
            ariaLabel={String(t('Support'))}
          >
            <IconSvg name='mark' />
          </Button>
        </div>
      </header>
      <div className='auth-section'>
        <Outlet />
      </div>
    </div>
  );
};

export default memo(
  withGlobal((global): StateProps => {
    const { authState } = global;
    return { authState };
  })(AuthLayout)
);
